import React, {useEffect, useRef, useState} from 'react';
import withStore from "@/hocs/withStore";
import Dialog from '@material-ui/core/Dialog';
import {styled} from "@mui/material/styles";
import Rating from "@mui/material/Rating";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";
import Svg from "@/Pages/All/Svg";
import {useForm} from "@inertiajs/inertia-react";
import InputError from "@/Components/form/InputError";
import TextAgreement from "@/Components/TextAgreement";

const StyledRating = styled(Rating)({
    '& .MuiRating-iconFilled': {
        color: '#006856',
    },
    '& .MuiRating-iconHover': {
        color: '#006856',
    },
});

const WriteReviewModal = (props) => {
    const {stores = {}, success = {}} = props;
    const {modalStore = {}} = stores;
    const [dragActive, setDragActive] = useState(false);
    const [pageExpiredMessage, setPageExpiredMessage] = useState('');
    const inputFileRef = useRef(null);

    // Если сессия истекла
    useEffect(() => {
        if (success && success.hasOwnProperty('pageExpiredMessage')) {
            setPageExpiredMessage(success.pageExpiredMessage);
        }
    }, [success]);

    const initialValues = {
        text: '',
        rating: 5,
        files: [],
        product_id: modalStore.reviewProductId,
        errorMessage: '',
    }
    const {data, setData, post, processing, errors, reset, transform} = useForm(initialValues);

    /**
     * Звезды
     * @param object
     * @param number
     */
    const onChangeRating = (object, number) => {
        setData('rating', number)
    };

    /**
     * Обработка инпутов
     * @param event
     */
    const onHandleChange = (event) => {
        setData(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value);
    };

    /**
     * Перемещение файлов "уронить" в определенную область
     * @param event
     */
    const handleDrag = function (event) {
        // Чтобы файл по умолчанию не открывался в новой вкладке браузера
        event.preventDefault();
        event.stopPropagation();
        if (event.type === "dragenter" || event.type === "dragover") {
            setDragActive(true);
        } else if (event.type === "dragleave") {
            setDragActive(false);
        }
    };

    /**
     * Получение списка файлов, которые мы "уронили" на компонент
     * @param event
     */
    const handleDrop = function (event) {
        event.preventDefault();
        event.stopPropagation();
        setDragActive(false);
        if (event.dataTransfer.files && event.dataTransfer.files[0]) {
            setData('files', Array.from(event.dataTransfer.files))
        }
    };

    /**
     * Открыть файловый браузер
     */
    const showOpenFileDialog = () => {
        if (inputFileRef.current !== null) {
            inputFileRef.current.click();
        }
    };

    /**
     * Обработка файлов
     * @param event
     */
    const onFilesChange = (event) => {
        setData('files', Array.from(event.target.files))
    };

    /**
     * Удаление 1 файла
     * @param file
     */
    const deleteFile = (file) => {
        const files = data.files.filter((el) => el !== file);
        setData('files', files);
    }

    /**
     * Добавить или изменить данные перед отправкой
     */
    transform((data) => ({
        ...data,
        product_id: modalStore.reviewProductId,
    }));

    /**
     * Отправка формы
     * @param e
     */
    const handleSubmit = (e) => {
        e.preventDefault();
        post(route('requestWriteReview'), {
            onSuccess: (page) => {
                modalStore.closeModalWriteReview();
                reset();
                reachGoalYM('add_review');
                reachGoalGA('add_review');
            },
        });
    };

    return <>
        <Dialog id={`modal`}
                className={`modal modal__writeReview`}
                open={modalStore.writeReviewModalFlag}
                onClose={() => modalStore.closeModalWriteReview()}
                aria-labelledby={`form-dialog-title`}
                fullWidth>
            <div className={`modal__header`}>
                <div className={`dagger-box`} onClick={() => modalStore.closeModalWriteReview()}>
                    <Svg id={`dagger-close`} className={`svg__dagger-close`} />
                </div>
                <div className={`modal-title`}>Отзыв</div>
                <StyledRating name={`half-rating-read`}
                              className={`styledRating`}
                              defaultValue={5}
                              value={Number(data.rating)}
                              precision={1}
                              onChange={(object, number) => onChangeRating(object, number)}
                />
            </div>
            <div className={`modal__body`}>
                <form className={`form form__writeReview${processing ? ' load' : ''}`} onSubmit={handleSubmit}>
                    <div className={`form__itemNew`}>
                        <textarea name={`text`}
                                  value={data.text}
                                  onChange={onHandleChange}
                                  placeholder={`Текст отзыва`}
                                  className={`text-inputNew text-inputNew__commentNew${errors.text ? ' error' : ''}`}
                        />
                        <label className={`text-labelNew`}>Текст отзыва</label>
                        <InputError message={errors.text} />
                    </div>
                    <div className={`form__itemNew`}>
                        <div className={`filesReview`}>
                            <p className={`filesReview__title`}>Фото вашего украшения</p>
                            <input type={`file`}
                                   name={`files`}
                                   ref={inputFileRef}
                                   accept={`image/*`}
                                   multiple
                                   onChange={onFilesChange}
                                   style={{'display': 'none'}}
                            />
                            <div className={`filesReview__dropzoneList${dragActive ? ' active' : ''}`}
                                 onClick={showOpenFileDialog}
                                 onDragEnter={handleDrag}
                                 onDragLeave={handleDrag}
                                 onDragOver={handleDrag}
                                 onDrop={handleDrop}
                            >
                                Выберите или перетащите изображения (max - 5шт.)
                            </div>
                            <InputError message={errors.files} className={`mt8`} />
                            {data.files.length !== 0 && (
                                <div className={`filesReview__fileListContainer`}>
                                    {data.files.map((file, index) => {
                                        let preview = file.type.startsWith('image/') ? URL.createObjectURL(file) : null;
                                        return <div key={index} className={`filesReview__fileList`}>
                                            {preview !== null ?
                                                <>
                                                    <div className={`filesReview__preview`}>
                                                        <img src={preview} />
                                                    </div>
                                                    <div className={`filesReview__content`}>
                                                        <div>{file.name}</div>
                                                        <div>Kb</div>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <div className={`filesReview__preview`}>
                                                        <img src={`/storage/img/all/is-not-image.png`} />
                                                    </div>
                                                    <div className={`filesReview__content filesReview__content_isNotImage`}>
                                                        Загружаемый файл не является изображением!
                                                    </div>
                                                </>
                                            }
                                            <div className={`filesReview__remove`} onClick={() => deleteFile(file)}>
                                                <Svg id={`dagger-close`} className={`svg__dagger-close`} />
                                            </div>
                                        </div>
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                    <TextAgreement />
                    <InputError message={errors.errorMessage} className={`errorMessage`} />
                    <InputError message={pageExpiredMessage} className={`errorMessage`} />
                    <button type={`submit`} className={`btn btn__submit`} disabled={processing}>
                        Отправить
                    </button>
                </form>
            </div>
        </Dialog>
    </>
}

export default withStore(WriteReviewModal);

